/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Category the link belongs to, used by the FE for grouping.
 */
export type AdditionalLinkType = (typeof AdditionalLinkType)[keyof typeof AdditionalLinkType];

export const AdditionalLinkType = {
  european_federation: "european_federation",
  international_federation: "international_federation",
  other: "other",
} as const;
